export const USDollar = new Intl.NumberFormat(
	'en-US',
	{
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0
	}
);

export function dateFormat( datestr, locale = 'en-US' ) {
	const date = new Date( datestr );

	return `${date.toLocaleDateString( locale, { month: 'long' } ) } ${ date.toLocaleDateString( locale, { year: 'numeric' } ) }`;
}

const textareaDecoder = document.createElement('textarea');

export function htmlDecode( str ) {
	textareaDecoder.innerHTML = str;
	str = textareaDecoder.textContent;
	textareaDecoder.innerHTML = '';

	return str;
}

export function noop() {
	// no-operation
}
